import {getDeviceHC, getDeviceMemory, getDeviceTier} from './helpers/device'
import {getConnectionType} from './helpers/getConnectionType'
import {isFramed} from './helpers/parent'
import {getServiceworkerStatus} from './helpers/getServiceworkerStatus'

performLowPriorityAction(() => {
  try {
    Ya.Rum.logEventString('init_local_time', new Date().toISOString())
  } catch (error) {
    console.error(error)
  }
})

performLowPriorityAction(() => {
  try {
    const swStatus = getServiceworkerStatus()

    if (swStatus) {
      Ya.Rum.logEventString('init_sw_status', swStatus)
    }
  } catch (error) {
    console.error(error)
  }
})

performLowPriorityAction(() => {
  try {
    Ya.Rum.logEventString('init_is_framed', String(isFramed))
  } catch (error) {
    console.error(error)
  }
})

performLowPriorityAction(() => {
  try {
    const connectionType = getConnectionType()

    if (connectionType) {
      Ya.Rum.logEventString('init_connection_type', connectionType)
    }
  } catch (error) {
    console.error(error)
  }
})

performLowPriorityAction(() => {
  try {
    Ya.Rum.logEventInteger('init_screen_size_width', window.document.documentElement.clientWidth)
    Ya.Rum.logEventInteger('init_screen_size_height', window.document.documentElement.clientHeight)
  } catch (error) {
    console.error(error)
  }
})

performLowPriorityAction(() => {
  try {
    const deviceMemory = getDeviceMemory()
    const deviceHC = getDeviceHC()
    const deviceTier = getDeviceTier(deviceMemory, deviceHC)

    if (deviceTier) {
      Ya.Rum.logEventString('init_device_info', deviceTier, {
        additional: {
          deviceHC,
          deviceMemory
        }
      })
    }
  } catch (error) {
    console.error(error)
  }
})

function performLowPriorityAction(callback: () => void) {
  if ('requestIdleCallback' in window && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, {timeout: 1_000})
    return
  }

  setTimeout(callback, 1_000)
}
